/**
 * X (formerly Twitter) brand glyph (monochrome, inherits `currentColor`).
 *
 * lucide-react dropped brand marks and its remaining `Twitter` export is the old
 * bird, so this is our canonical X mark. Same shape and rationale as
 * `WhatsAppIcon` — a single-path official logo that still reads at h-4 w-4.
 *
 * The brand HUE is not here: it lives on the `x` entry in
 * `shared/config/social_platforms.config.json` with every other platform's, so
 * adding a sixth brand stays a config line.
 */
import React from 'react';

import { cn } from '../../../lib/utils';

export function XIcon({ className, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
      className={cn('h-4 w-4', className)}
      {...props}
    >
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </svg>
  );
}
